import { Enum_Questiontree_Treetype } from '@cyren/common-lib';
import classNames from 'classnames';
import { size } from 'lodash';
import { memo } from 'react';
import { ImArrowLeft2 } from 'react-icons/im';
import { useNavigate } from 'react-router';
import useInAdminDashboard from '../../../../../admin/hooks/use-in-admin-dashboard';
import { usePatientLocale } from '../../../../hooks/use-patient-locale';
import LogoPatientDynamic from '../../../../../components/LogoPatientDynamic';
import ProgressBar from './ProgressBar';

type HeaderSurvey = {
  questionTreeKeys?: string[];
};

type HeaderTree = {
  treeType?: Enum_Questiontree_Treetype;
  treeKey?: string;
};

function PaTreeHeader({
  survey,
  tree,
  showFullBar,
  noBack,
  logoUrl,
  stepKeys,
  currentTreeKey,
  onBack,
}: {
  survey?: HeaderSurvey | null;
  tree?: HeaderTree | null;
  showFullBar?: boolean;
  noBack?: boolean;
  logoUrl?: string | null;
  stepKeys?: string[];
  currentTreeKey?: string;
  onBack?: () => void;
}) {
  const { inAdminPanel } = useInAdminDashboard();
  const nav = useNavigate();
  const { isRtl } = usePatientLocale();

  const treeKey = currentTreeKey || tree?.treeKey || '';
  const normalizedStepKeys = stepKeys?.filter(Boolean) || [];
  const stepKeysEnabled = normalizedStepKeys.length > 0;
  const isStepTree =
    stepKeysEnabled ||
    tree?.treeType === Enum_Questiontree_Treetype.Step ||
    String(tree?.treeType || '').toLowerCase() === 'step';
  const treeIdx = stepKeysEnabled
    ? normalizedStepKeys.indexOf(treeKey)
    : survey?.questionTreeKeys?.findIndex((k) => k === treeKey);
  const stepCount = stepKeysEnabled ? normalizedStepKeys.length : size(survey?.questionTreeKeys);
  const currentIdx = treeIdx != null && treeIdx >= 0 ? treeIdx : 0;

  return (
    <div className='px-0 flex justify-between min-h-[2.8rem]'>
      {!noBack && !inAdminPanel && (
        <div className='relative'>
          <button
            className={classNames(
              'btn btn-ghost absolute overflow-visible',
              isRtl ? 'right-0 rotate-180' : 'left-0',
            )}
            onClick={() => {
              if (onBack) {
                onBack();
                return;
              }
              nav(-1);
            }}
          >
            <ImArrowLeft2 size={20} />
          </button>
        </div>
      )}
      <div className='flex-col w-full h-full py-4 px-8'>
        {showFullBar ? (
          <ProgressBar current={4} stepCount={4} />
        ) : (
          <>
            {isStepTree && stepCount > 0 ? (
              <ProgressBar current={currentIdx} stepCount={stepCount} />
            ) : (
              <LogoPatientDynamic logoUrl={logoUrl} className='w-9' />
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default memo(PaTreeHeader);
